import { React, useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import FetchModule from '../../Share/Network/FetchModule';
import { useLanguage } from '../../../Context/LanguageContext';

import NewCommentTextArea from '../../../Component/NoticeComponent/NewCommentTextArea';

import ExitImage from '../../../image/ImageExit.png';

const NewCommentWriteBox = (props) => {
  const { noticeId, rendering, commentRef, name, commentId } = props;

  const history = useHistory();
  const { t } = useLanguage();

  const [value, setValue] = useState('');
  const [image, setImage] = useState(undefined);

  const InputRef = useRef();
  const ImageRef = useRef();

  useEffect(() => {
    if (name !== undefined) {
      InputRef.current.setValue(name + ' ');
    }
  }, [name])

  function changeFn(value) {
    setValue(value);
  }

  function imageExitClick() {
    setImage(undefined);
    ImageRef.current.reset();
  }

  function saveCommentClick() {
    if (value === '' || value === undefined) {
      alert(t('noticePage.contentPlaceholder'));
      return;
    }

    if (value.length > 3000) {
      alert(t('noticePage.alertExceedCharLimit'));
      return;
    }

    const storeId = window.sessionStorage.getItem('StoreId');
    const memberId = -1;
    const text = value;

    // 댓글을 선택했거나 이름을 지우지 않았을 경우
    if (commentId !== -1 && name.length <= value.length) {
      // 답글로 적기

      let data = {
        storeId: parseInt(storeId),
        noticeId: parseInt(noticeId),
        memberId: memberId,
        commentId: commentId,
        text: text,
        image: ''
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postData('notice/reply/create', 'POST', data);
          if (responseData.status === 200) {
            InputRef.current.reset();
            rendering();
          }
          else if (responseData.status === 401) history.push('/');
          else if (responseData.status !== 204) alert(t('noticePage.alertServerErrorNewline'));
        }
      )();
    }
    else {
      // 댓글로 적기
  
      let data = {
        storeId: parseInt(storeId),
        noticeId: parseInt(noticeId),
        memberId: memberId,
        text: text,
        image: ''
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postData('notice/comment/create', 'POST', data);
          if (responseData.status === 200) {
            InputRef.current.reset();
            rendering();
          }
          else if (responseData.status === 401) history.push('/');
          else if (responseData.status !== 204) alert(t('noticePage.alertServerErrorNewline'));
        }
      )();
    }
  }

  return (
    <TopLevelWrapper>
      <LeftWrapper>
        <Title>{t('noticePage.comment.write')}</Title>
        <CommentBox >
          <NewCommentTextArea id="test" ref={InputRef} placeholder={t('noticePage.contentPlaceholder')} changeFn={changeFn}/>
        <ImageBox isView={image !== undefined}>
          <ExitButton buttonPath={ExitImage} onClick={imageExitClick}/>
          <Image src={image ? URL.createObjectURL(image) : ''}/>
        </ImageBox>
        </CommentBox>
      </LeftWrapper>
      <RightWrapper>
        <CharacterCount>{value.length}/3000</CharacterCount>
        <ButtonWrapper>
          <SaveButton ref={commentRef} available={value.length !== 0} onClick={saveCommentClick}>{t('noticePage.comment.register')}</SaveButton>
        </ButtonWrapper>
      </RightWrapper>
    </TopLevelWrapper>
  )
}

export default NewCommentWriteBox;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 16px;

`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 8px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const CommentBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
`;

const ImageBox = styled.div`
  display: ${props => props.isView ? `flex` : `none`};
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  margin: 8px 8px 8px 8px;
`;

const Image = styled.img`
  width: 160px;
  height: 160px;

`;

const ExitButton = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  border-radius: 24px;
  background: url(${props => props.buttonPath}) no-repeat center center;
  background-color: rgba(0, 0, 0, 0.5);

  margin: 10px 10px 0 0;

  &:hover {
    cursor: pointer;
  }
`;

const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 24px;
`;

const CharacterCount = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.line};

  margin: 50px 0 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 66px;
  height: 38px;

  border: ${props => props.available ? `1px solid ${props.theme.subKey}` : `1px solid ${props.theme.line}`};
  border-radius: 15px;
  background-color: ${props => props.available ? props.theme.subKey : props.theme.subBackground};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.available ? props.theme.subBackground : props.theme.line};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      border: ${props => props.available ? `1px solid ${props.theme.subKeyHover}` : `1px solid ${props.theme.subText}`};
      color: ${props => props.available ? props.theme.subBackground : props.theme.subText};
      background-color: ${props => props.available ? props.theme.subKey : props.theme.subBackground};
    }
  }
`;